module.exports = __webpack_public_path__ + "static/media/github-cards.2cf29cd1.png";